var React = require('react');

function StarRate (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("path",{"fill":"#fd7200","stroke":"#fd7200","strokeLinecap":"round","strokeLinejoin":"round","d":"M8 .74l1.731 5.529H15.5l-4.584 3.445 1.802 5.546L8 11.832 3.282 15.26l1.802-5.546L.5 6.269h5.769z","key":1})]));
}

StarRate.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = StarRate;

StarRate.default = StarRate;
